export default {"src":"/_next/static/media/certora-icon.daa1b6cf.svg","height":40,"width":38,"blurWidth":0,"blurHeight":0};